// extracted by mini-css-extract-plugin
export var hgroup = "SiteTitle-module--hgroup--1bp-K";
export var h1 = "SiteTitle-module--h1--GurX-";
export var h2 = "SiteTitle-module--h2--3Ofbg";